import {
  SaveExtractHistoryCacheUsecase,
  SaveExtractHistoryCacheUsecaseImpl,
} from 'domain/usecases/extract/save-extracts-history-cache-usecase';
import { makeSaveExtractFromCacheRepository } from '../repositories/cache/extract-history-repository-factory';

export const makeSaveExtractsHistoryUsecase = (): SaveExtractHistoryCacheUsecase => {
  return new SaveExtractHistoryCacheUsecaseImpl(makeSaveExtractFromCacheRepository());
};
